import { components } from "react-select";
import {IoChevronDownOutline} from "react-icons/io5";

// Кастомный компонент для иконки дропдауна
export const DropdownIndicator = (props: any) => {
    const hasValue = props.hasValue;
    const isOpen = props.selectProps.menuIsOpen;
    return (
        <components.DropdownIndicator {...props}>
            <IoChevronDownOutline
                size={24}
                color={hasValue || isOpen ? '#363636' : 'rgba(255, 255, 255, 0.70)'}
                style={{
                    transition: 'transform 0.2s ease',
                    transform: isOpen ? 'rotate(-180deg)' : 'rotate(0)',
                }}
            />
        </components.DropdownIndicator>
    );
};